import { useEffect, useRef } from 'react';
import { registrarAtalho, type Atalho } from './registro';

/** Registra enquanto o componente vive; a função executada é sempre a mais recente (sem re-registrar a cada render). */
export function useAtalho(a: Atalho, ativo = true) {
  const atual = useRef(a);
  useEffect(() => {
    atual.current = a;
  });
  const teclas = a.teclas.join('|');
  useEffect(() => {
    if (!ativo) return undefined;
    return registrarAtalho({
      ...atual.current,
      quando: () => atual.current.quando?.() ?? true,
      executar: (e) => atual.current.executar(e),
    });
  }, [a.id, a.escopo, teclas, ativo]);
}

/** Alvo do evento é campo editável (para atalhos de letra não roubarem digitação). */
export function emCampoEditavel(e: KeyboardEvent): boolean {
  const t = e.target as HTMLElement | null;
  return !!t && (t.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName));
}
